import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormElement } from '@app/modules/form-generator/edit-form-v3/models/form.model';
import { TableListFieldOption } from '@app/modules/lookup/models/lookup.model';
import { PagedData } from '@app/modules/lookup/models/paged-data.model';
import { LookupService } from '@app/modules/lookup/services/lookup.service';
import { BuySellService } from '@app/modules/time-off/services/buy-sell.service';
import moment from 'moment';
import { from, map, Observable, of } from 'rxjs';

@Component({
  selector: 'app-dropdown-list-form-field',
  templateUrl: './dropdown-list-form-field.component.html',
  styleUrls: ['./dropdown-list-form-field.component.scss']
})
export class DropdownListFormFieldComponent implements OnInit {
  @Input() formElement: FormElement;
  @Input() parentGroup: UntypedFormGroup;
  @Input() readOnly: boolean;
  dropdownListOptions: Observable<PagedData<TableListFieldOption>>;


  constructor(
    private lookupService: LookupService,
    private buySellService: BuySellService
  ) { }

  ngOnInit(): void {
    this.getDropdownListOptions();
  }

  getDropdownListOptions() {
    if (this.formElement?.listOptions) {
      this.dropdownListOptions = of(JSON.parse(this.formElement.listOptions) as PagedData<TableListFieldOption>);
    }
    else if (this.formElement?.lookupGroup) {
      this.dropdownListOptions = from(this.lookupService.getListOptions(this.formElement?.lookupGroup));
    }
    else if (this.formElement?.listType === 'buySellPlanStatuses') {
      this.dropdownListOptions = this.buySellService.getBuySellPlanStatuses().pipe(
        // Map the result to the correct type for dropdownListOptions
        // and wrap it in an observable
        // so the assignment matches the expected type
        // (Observable<PagedData<TableListFieldOption>>)
        // and avoids the type error
        // (Argument of type 'PagedData<TableListFieldOption>' is not assignable to parameter of type 'ObservableInput<any>')
        // Use RxJS map operator
        // import { map } from 'rxjs/operators'; if not already imported
        map(result => this.convertToPagedDataTableListFieldOption(result))
      );
    }
    else if (this.formElement?.listType === 'buySellPlanReviewerTypes') {
      this.dropdownListOptions = this.buySellService.getReviewerTypes().pipe(
        map(result => this.convertToPagedDataTableListFieldOption(result))
      );
    }
    else {
      this.dropdownListOptions = of({
        data: [],
        total: 0,
        skip: 0,
        take: 0,
        totalPages: 0
      });
    }
  }

  convertToPagedDataTableListFieldOption(input: any): PagedData<TableListFieldOption> {
    return {
      data: input.data.map(item => ({
        id: item.id,
        text: item.name,
        startDate: item.startDate ?? null,
        endDate: item.endDate ?? null,
        prioritize: item.prioritize ?? false
      })),
      skip: input.skip,
      take: input.take,
      total: input.total,
      totalPages: input.take > 0 ? Math.ceil(input.total / input.take) : 0
    };
  }

  isCurrentLookupItem(endDate: string) {
    if (endDate === null) {
      return true;
    }

    return moment().diff(endDate) < 0;
  }
}
